import { DateTime } from 'luxon';
import { projectService } from 'ogp/services';
import { useQuery } from 'react-query';
import { formatFullName } from 'shared/utils/formatting';
import { FirstParamOfFn } from '@types';
import { QUERY_KEYS } from 'api/query-keys';

export const useGetProjectsCheckoutsArchive = (
  params: FirstParamOfFn<typeof projectService.getCheckoutsArchive>
) => {
  const query = useQuery(QUERY_KEYS.projectsCheckoutsArchive(params), {
    queryFn: async () => await projectService.getCheckoutsArchive(params),
    keepPreviousData: true,
    select: (data) => ({
      ...data,
      items: data.items.map((item) => {
        const transformedItem = {
          id: item.id,
          state: item.state,
          createdAt: DateTime.fromISO(item.proposal.createdAt).toFormat('EEE, dd MMM yyyy'),
          flexWorker: {
            fullName: formatFullName(item.flexWorker),
            id: item.flexWorker.id,
          },
          placement: {
            id: item.placement.id,
          },
          project: item.project.name,
          proposal: {
            startDate: item.proposal.startDate,
            endDate: item.proposal.endDate,
          },
          breakMinutes: item.proposal.breakMinutes,
          workedFrom: DateTime.fromISO(item.proposal.startDate).toFormat('EEE, dd MMM yyyy, HH:mm'),
          workedTo: DateTime.fromISO(item.proposal.endDate).toFormat('EEE, dd MMM yyyy, HH:mm'),
          expense: item.proposal.expense,
          branchOffice: item.branchOffice,
          department: item.department,
        };

        return {
          actions: transformedItem,
          ...transformedItem,
        };
      }),
    }),
  });

  return query;
};
